// This module toggles the Form description container when clicking on the Help icon.
const toggleFormDescription = () => {
	const $descriptionElement = $( '.js-toggle-form-description-text' );
	if ( !$descriptionElement.length ) {
		return;
	}

	const $helpIconElements = $( '.js-toggle-form-description-icon' );

	$helpIconElements.on( 'click', () => {
		$descriptionElement.slideToggle();
		$helpIconElements.toggleClass( 'active' );
	});
};

export default toggleFormDescription;